import './App.css';
import Weather from './Weather';

function App() {
  return (
<div className='App'>
  <div className='container'>

    <h1> Weather App</h1>
    <Weather defaultCity="Berlin"/>

    <footer>This project was coded by Dajana and is <a href="https://github.com/dajana-lab/weather-react-app.git">open-sourced on Github</a> and it is hosted on Netlify</footer>
    </div>
    </div>
  );
}

export default App;
